import React, { useContext } from "react";
import "./home-style.css";
import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const MeetFlxDeck = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.meetFlxdeck : jsonDataFr.data.meetFlxdeck;
  return (
    <section className="meet-section">
      <div className="meet-inner">
        <div className="meet-text">
          <h2 className="meet-title">
            {data.title1} <span className="accent">FlxDeck</span>:<br />
            {data.title2}
          </h2>

          <p className="meet-desc">{data.description1}</p>

          <p className="meet-desc">{data.description2} </p>

          <ul className="meet-list">
            <li>{data.item1}</li>
            <li>{data.item2}</li>
            <li>{data.item3}</li>
            <li>{data.item4}</li>
            <li>{data.item5}</li>
          </ul>

          <a href="#contact" className="meet-cta">
            {data.btn}
          </a>
        </div>

        <div className="meet-media">
          {/* Replace the src with your transparent PNG */}
          <img src="/assets/home/mobile_mockup.webp" alt="FlxDeck mobile screens" className="meet-image" />
        </div>
      </div>
    </section>
  );
};

export default MeetFlxDeck;
